import { Component, Inject, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../../app/services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';
import { HttpException } from '@rubii/share/src/classes';
import { Dsps } from '@rubii/share/src/constants';


@Component({
  selector: 'app-dv360',
  templateUrl: './dv360.component.html',
  styleUrls: ['./dv360.component.scss']
})
export class Dv360Component extends BaseDatasourceComponent implements OnInit {


  constructor(@Inject(MAT_DIALOG_DATA) public data: { dataSourceId: number, availablePartners: {partnerId: string, displayName: string}[] }, private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.partnerIds = new FormControl([], [Validators.required]);
  }

  connect() {
    this.client.account.addPartnerIds({dataSourceId: Dsps.DV360, partnerIds: this.partnerIds.value})
      .then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed'); 
        this.dialogRef.close({dataSourceId: Dsps.DV360});
      })
      .catch(e => this.openSnackBarWarning(this.snackBar, (e as HttpException).message, 'closed'));
  }
}
